import React, { useState } from 'react';
import { Github, Twitter, Linkedin, Mail } from 'lucide-react';
import { CookiesModal } from './CookiesModal';
import { PrivacyModal } from './PrivacyModal';
import { TermsModal } from './TermsModal';
export function Footer() {
  const [isCookiesOpen, setIsCookiesOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const footerLinks = {
    producto: [{
      label: 'Características',
      href: '#'
    }, {
      label: 'Seguridad',
      href: '#seguridad'
    }, {
      label: 'Integraciones',
      href: '#'
    }, {
      label: 'Precios',
      href: '#'
    }, {
      label: 'API',
      href: '#'
    }],
    empresa: [{
      label: 'Sobre nosotros',
      href: '#'
    }, {
      label: 'Contacto',
      href: '#contacto'
    }],
    legal: [{
      label: 'Políticas de Privacidad',
      href: '#'
    }, {
      label: 'Términos y Condiciones',
      href: '#'
    }, {
      label: 'Cookies',
      href: '/cookies'
    }, {
      label: 'Cumplimiento',
      href: '#'
    }, {
      label: 'Licencias',
      href: '#'
    }]
  };
  const socialLinks = [{
    icon: Twitter,
    href: '#',
    label: 'Twitter'
  }, {
    icon: Linkedin,
    href: '#',
    label: 'LinkedIn'
  }, {
    icon: Github,
    href: '#',
    label: 'GitHub'
  }, {
    icon: Mail,
    href: '#',
    label: 'Email'
  }];
  return <footer id="contacto" className="bg-navy-900 border-t border-teal-500/10" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-111">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-112">
          {/* Logo & Description */}
          <div className="col-span-2 md:col-span-1" data-id="element-113">
            <a href="#" className="flex items-center mb-4" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/4uYFjyswBHJgHa3j3GEUbF/tru_Id_fondonegro.png" alt="TruID" className="h-8 w-auto" data-id="element-115" />
            </a>
            <p className="text-sm text-gray-400 mb-6" data-id="element-116">
              Identidad digital segura, privada y bajo tu control. TruID.
            </p>
            <div className="flex space-x-4" data-id="element-117">
              {socialLinks.map(social => {
              const Icon = social.icon;
              return <a key={social.label} href={social.href} className="w-9 h-9 bg-navy-800 border border-teal-500/20 rounded-lg flex items-center justify-center hover:border-teal-500 hover:bg-teal-500/10 transition-all" aria-label={social.label} data-id="element-118">
                    <Icon size={18} className="text-gray-400" data-id="element-119" />
                  </a>;
            })}
            </div>
          </div>

          {/* Product Links */}
          <div data-id="element-120">
            <h3 className="font-display font-semibold text-white mb-4" data-id="element-121">
              Producto
            </h3>
            <ul className="space-y-3" data-id="element-122">
              {footerLinks.producto.map(link => <li key={link.label} data-id="element-123">
                  <a href={link.href} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-124">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Company Links */}
          <div data-id="element-125">
            <h3 className="font-display font-semibold text-white mb-4" data-id="element-126">
              Empresa
            </h3>
            <ul className="space-y-3" data-id="element-127">
              {footerLinks.empresa.map(link => <li key={link.label} data-id="element-128">
                  <a href={link.href} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-129">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-130">
            <h3 className="font-display font-semibold text-white mb-4" data-id="element-131">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-132">
              {footerLinks.legal.map(link => <li key={link.label} data-id="element-133">
                  {link.label === 'Cookies' ? <button onClick={() => setIsCookiesOpen(true)} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-134">
                      {link.label}
                    </button> : link.label === 'Políticas de Privacidad' ? <button onClick={() => setIsPrivacyOpen(true)} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-135">
                      {link.label}
                    </button> : link.label === 'Términos y Condiciones' ? <button onClick={() => setIsTermsOpen(true)} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-136">
                      {link.label}
                    </button> : <a href={link.href} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-137">
                      {link.label}
                    </a>}
                </li>)}
            </ul>
          </div>
          <CookiesModal isOpen={isCookiesOpen} onClose={() => setIsCookiesOpen(false)} data-id="element-138" />
          <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-139" />
          <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-140" />
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-teal-500/10" data-id="element-141">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-142">
            <p className="text-sm text-gray-500" data-id="element-143">
              © 2026 TruID.org — Todos los derechos reservados
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-500" data-id="element-144">
              <span data-id="element-145">Hecho con ❤️ para un internet más seguro</span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}